import { map, noop } from 'lodash';
import { REFUND_TYPES } from '@nandosaus/constants';
import { useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';

import { Box, Flex } from '../../grid';
import { Button } from '../../button';
import { P } from '../../typography';

const Confirmation = ({ goBack }) => {
  const { OrderHelpStore } = useRootStore();

  const getConfirmationContent = () => {
    if (OrderHelpStore.refundType === REFUND_TYPES.REFUND) {
      const refundIsForPoints = Boolean(OrderHelpStore.refundValuePoints);
      const refundValueString = refundIsForPoints
        ? `Good News! We've refunded you ${OrderHelpStore.refundValuePoints} points back to your PERi-Perks account. It will reflect in your account within the next 24 hours and you'll get an email once processed.`
        : `Good news! We've refunded your order amount of $${OrderHelpStore.refundValue.toFixed(
            2
          )}. It'll be in your nominated account within 5-7 business days and you'll get an email confirmation once it has been processed.`;
      return [
        refundValueString,
        `We're sorry your order wasn't up to standard this time and look forward to making it up to you soon.`,
      ];
    }
    if (OrderHelpStore.refundType === REFUND_TYPES.VOUCHER) {
      return [
        `Good news! We've sent you an email with your gift card which can be used either online or at your local Nando’s.`,
        `We're sorry your order wasn't what you expected and we're looking forward to making it up to you on the next visit.`,
      ];
    }

    return [
      `Unfortunately, we're unable to process a voucher or refund at the moment.`,
      `But don't worry! We've escalated your request for a full investigation. We'll also make sure our friendly Customer Care Team gets back to you ASAP via email.`,
    ];
  };

  return (
    <Box>
      <Flex flexDirection="column">
        {map(getConfirmationContent(), line => (
          <P variant={3} mb={1}>
            {line}
          </P>
        ))}
      </Flex>
      <Button onClick={goBack}>Back Home</Button>
    </Box>
  );
};
Confirmation.propTypes = {
  goBack: PropTypes.func,
};
Confirmation.defaultProps = {
  goBack: noop,
};
export { Confirmation };
